module.exports = __webpack_public_path__ + "static/media/status2.cd6f391d.png";